import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
// jQuery の $.ajax に CSRF トークンを自動付与（@rails/ujs は付けないため）
import "../javascript/csrf_ajax_prefilter";
import "@mdi/font/css/materialdesignicons.css"; // MDI アイコン（#33: 旧 sprockets icons.scss はフォント欠落で 404 だった）
// FontAwesome（Issue #181）。MDI と同じくウェブフォント版を読む。
//
// 以前はここに「ダッシュボードのアイコンは public/fontawesome.min.css が描画して
// いる」と書いてあったが、誤りだった。あの CSS は FA5 の**コアだけ**で、
// @font-face も font-family も 1 つも入っていない。クラスと content はあるのに
// フォントが無いので、全アイコンが本文フォントで私用領域を描こうとして豆腐に
// なっていた（本番の実ブラウザで確認）。
//
// FA5 は CSS が分割されている:
//   fontawesome.css              クラス定義と content   ← これだけ入っていた
//   brands/solid/regular.css     @font-face と font-family ← 無かった
// all.min.css はこれらを全部含む。フォント実体も同梱されている。
//
// 6 系はクラス名が変わる（fab → fa-brands など）ので 5 系に固定する。
// ビューは fab / fa- 記法なので、上げるならビュー側の一括置換とセット。
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../styles/dashboard/entry.scss";
// import swiper from "../javascript/vendor/swiper"
require("bootstrap");

require.context("../images", true, /\.(png|jpg|jpeg|svg)$/);
import * as Dropify from "../javascript/vendor/dropify";

import Rails from "@rails/ujs";
Rails.start();

// Toastrの設定
import toastr from "toastr";
toastr.options = {
  closeButton: true,
  timeout: 2000,
  preventDuplicates: true,
  // toastr は既定 escapeHtml: false で、メッセージを jQuery の append() に
  // 渡すため HTML として解釈される（node_modules/toastr/toastr.js:185, 362）。
  // custom_bootstrap_flash の escape_javascript は JS リテラルからの脱出しか
  // 防げないので、表示側でもテキスト化する（Codex 指摘）。
  // flash に HTML を意図的に入れている箇所は無いことを確認済み。
  escapeHtml: true,
};
global.toastr = toastr;
require("../styles/dropify.scss");

require.context("../images", true, /\.(png|jpg|jpeg|svg)$/);

$(document).ready(() => {
  // Initialize Dropify
  Dropify.activate({
    messages: {
      default: `
        <p class="dropify-text">ここに写真をドロップ<br>または</p>
        <p class="btn-dropify">写真を選択</p>
      `,
      replace: '<p class="dropify-text">ここに写真をドロップ<br>または</p>',
      remove: "削除",
      error: "Error",
    },
  });

  // Handle remote links
  // $(document).on("click", 'a[data-remote="true"]', async (e) => {
  //   e.preventDefault();
  //   const $this = $(e.currentTarget);

  //   try {
  //     await $.ajax({
  //       url: $this.attr("href"),
  //       type: "GET",
  //     });
  //   } catch (error) {
  //     console.error("Ajax request failed:", error);
  //     toastr.error("リクエストに失敗しました");
  //   }
  // });
});
